export const BackArrowCircleIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
        <circle cx="26.8701" cy="26.8702" r="19" transform="rotate(-135 26.8701 26.8702)" fill="#303030"/>
        <path d="M35.3553 27.8701C35.9076 27.8701 36.3553 27.4224 36.3553 26.8701C36.3553 26.3178 35.9076 25.8701 35.3553 25.8701L35.3553 27.8701ZM19.0919 26.163C18.7014 26.5535 18.7014 27.1867 19.0919 27.5772L25.4559 33.9412C25.8464 34.3317 26.4795 34.3317 26.8701 33.9412C27.2606 33.5507 27.2606 32.9175 26.8701 32.527L21.2132 26.8701L26.8701 21.2133C27.2606 20.8227 27.2606 20.1896 26.8701 19.7991C26.4795 19.4085 25.8464 19.4085 25.4559 19.7991L19.0919 26.163ZM35.3553 25.8701L19.799 25.8701L19.799 27.8701L35.3553 27.8701L35.3553 25.8701Z" fill="#999999"/>
        </svg>
    `,
      }}
    />
  );
};
